import { type FC } from 'react'

import { CollapsibleContainer } from 'slab'
import { type BrokersTaskDetail } from 'utils/web_api.schemas'

import BrokersEnrollment from '../BrokersEnrollment'

type TaskEnrollmentDetailsProps = {
  task: BrokersTaskDetail
}

const TaskEnrollmentDetails: FC<TaskEnrollmentDetailsProps> = ({ task }) => {
  // Use the enrollment_id field from the task (resolved by backend based on related_type)
  // Note: enrollment_id is added to the Task entity in the backend
  // The TypeScript schema will need to be regenerated after the backend change
  const enrollmentId = task.enrollment_id
  const memberId = task.member_id

  // Don't render if we don't have the necessary data
  if (!enrollmentId || !memberId) {
    return null
  }

  return (
    <CollapsibleContainer
      heading='Enrollment Details'
      defaultOpen={false}
      headingLevel={3}
    >
      <div className='p-4'>
        <BrokersEnrollment
          memberId={memberId}
          enrollmentId={enrollmentId}
          editCoveragesPath={`/brokers/members/${memberId}/enrollments/${enrollmentId}/edit_coverages`}
          embedded
        />
      </div>
    </CollapsibleContainer>
  )
}

export default TaskEnrollmentDetails
